import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Typography, Link } from '@mui/material';
import { useProvider } from './hooks';
import { ProviderTable } from './ProviderTable';
import { CreateProviderModal } from './CreateProviderModal.tsx';
import { t } from 'i18next';
import { ProviderItem } from './components';
import { Dropdown, DropdownMenuItem } from '@components';
import { ImportProviderModal } from '@views/pages/Admin/Provider/ImportProviderModal.tsx';
import BadgeIcon from '@mui/icons-material/Badge';
import { theme } from '@store';
import { ArrowBack } from '@mui/icons-material';

export const Provider = () => {
  const {
    totalCount,
    entries = [],
    selectedProviderId,
    handleCloseDrawer,
    handleOpenProviderDetails,
    handleOpenCreateProviderModal,
    handleCloseCreateProviderModal,
    handleOpenImportProviderModal,
    handleCloseImportProviderModal,
    isCreateProviderModalOpen,
    isDrawerOpen,
    isImportProviderModalOpen,
    isLoading,
    isInitialFilters,
  } = useProvider();

  const dropdownMenu: DropdownMenuItem[] = [
    {
      iconName: 'badge',
      label: t('adminPanel.providers.dropdown.addProvider'),
      onClick: handleOpenCreateProviderModal,
    },
    {
      iconName: 'backup',
      label: t('adminPanel.providers.dropdown.importProviders'),
      onClick: handleOpenImportProviderModal,
    },
  ];

  return (
    <>
      <Box
        sx={{
          cursor: 'pointer',
          [theme.breakpoints.down('md')]: {
            display: 'none',
          },
          width: 'fit-content',
        }}
      >
        <Link
          href={'/admin'}
          underline='always'
          sx={{
            display: 'flex',
            justifyContent: 'start',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          <ArrowBackIcon sx={{ fontSize: '1.5rem' }} color='primary' />
          <Typography sx={{ color: 'primary' }}>
            {t('general.backToPrevious')}
          </Typography>
        </Link>
      </Box>
      <Box
        sx={{
          pt: '1rem',
          pb: '1rem',
          gap: '1rem',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
            <Box
              sx={{
                cursor: 'pointer',
                [theme.breakpoints.up('md')]: {
                  display: 'none',
                },
                width: 'fit-content',
              }}
            >
              <Link
                href={'/admin'}
                underline='always'
                sx={{
                  gap: 2,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start',
                }}
              >
                <ArrowBack
                  sx={{ fontSize: '2rem', color: 'rgba(0, 0, 0, 0.56)' }}
                  color='primary'
                />
              </Link>
            </Box>
            <Typography variant='h4'>
              {t('adminPanel.providers.title')}
            </Typography>
          </Box>

          <Dropdown menuList={dropdownMenu} />
        </Box>
      </Box>
      {entries.length === 0 && isInitialFilters && !isLoading ? (
        <Box
          sx={{
            height: 'calc(100vh - 310px)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            gap: 1,
          }}
        >
          <BadgeIcon sx={{ width: 56, height: 56, mb: 2 }} color='primary' />
          <Typography variant='h6'>
            {t('adminPanel.providers.noResults.title')}
          </Typography>
          <Typography variant='body2' sx={{ color: 'text.disabled' }}>
            {t('adminPanel.providers.noResults.subTitle')}
          </Typography>
        </Box>
      ) : (
        <ProviderTable
          rows={entries}
          onSelectProvider={handleOpenProviderDetails}
          totalCount={totalCount}
          selectedRowId={selectedProviderId}
          loading={isLoading}
        />
      )}
      {selectedProviderId && (
        <ProviderItem
          open={isDrawerOpen}
          itemId={selectedProviderId}
          handleClose={handleCloseDrawer}
        />
      )}
      <CreateProviderModal
        isOpen={isCreateProviderModalOpen}
        handleClose={handleCloseCreateProviderModal}
        handleOpenProviderDetails={handleOpenProviderDetails}
      />
      <ImportProviderModal
        isOpen={isImportProviderModalOpen}
        handleClose={handleCloseImportProviderModal}
      />
    </>
  );
};
